import { createContext, useContext } from 'react'

export const ProductConfigContext = createContext(null)

/**
 * @returns {{
 *   config: object,
 *   source: 'CL'|'LP',
 *   returnUrl: string|null,
 *   appendProductParams: (params?: URLSearchParams|Record<string,string>) => URLSearchParams,
 *   getReturnUrl: () => string,
 *   getEmailVerifiedReturnUrl: () => string
 * }}
 */
export const useProductConfig = () => {
  const value = useContext(ProductConfigContext)
  if (!value?.config) {
    throw new Error(
      'useProductConfig must be used within ProductConfigProvider with a valid source'
    )
  }
  return value
}
